Collection = require('./collection')
Model = require('./Model').default
Version = require('./Version')


module.exports = class Creatable extends Model
    initialize: ->
        #console.log('creatable inited', @)
        @set("versions", new Collection(@attributes.versions, {model: Version}))
		





// WEBPACK FOOTER //
// ./app/models/Creatable.coffee